import React, { useState, useEffect } from "react";

const CountdownTimer = ({ targetDate }) => {
  const [countdown, setCountdown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const intervalId = setInterval(() => {
      const now = new Date();
      const timeDifference = targetDate?.getTime() - now.getTime();

      if (timeDifference <= 0) {
        clearInterval(intervalId);
        // Handle countdown reaching zero
      } else {
        const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

        setCountdown({ days, hours, minutes, seconds });
      }
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [targetDate]);

  const formatTime = (value) => (value < 10 ? `0${value}` : value);

  return (
    <div>
      {`${formatTime(countdown.days)}d:${formatTime(
        countdown.hours
      )}h:${formatTime(countdown.minutes)}min:${formatTime(
        countdown.seconds
      )}s`}
    </div>
  );
};

export default CountdownTimer;
